import React from "react";
import { HomeSearchResultsTemplate } from "themes/application/home/components";

function HomeSearchResults(props) {
    return <HomeSearchResultsTemplate {...props} />;
}

export default HomeSearchResults;
